module.exports = __webpack_public_path__ + "static/7-IMG-2886-e5bd9437b88cf6fd7992be575ac94d96.jpg";